import { Injectable } from '@angular/core';
import { enumGroupReportReturnType, Report } from 'app/shared/models/report';
import { IReportService } from './base-report.service';
import { ReferralReportService } from './referral-report.service';
import { SystemReportService } from './system-report.service';

@Injectable({ providedIn: 'root' })
export class ReportHelper {

  constructor(
    private referralReportService: ReferralReportService,
    private systemReportService: SystemReportService,
  ) { }

  getReportService(report: Report): IReportService {
    if (report && report.config) {
      switch (report.config.returnType) {
        case enumGroupReportReturnType.Referral:
          return this.referralReportService;
        default:
          return this.systemReportService;
      }
    }
    else {
      // report/report.config not defined - assume the default
      return this.systemReportService;
    }
  }

  getBackUrl(report: Report): string {
    if (report && report.config) {
      switch (report.config.returnType) {
        case enumGroupReportReturnType.Referral:
          return "/referralreports"
        default:
          return "/reports";
      }
    }
    else {
      // report/report.config not defined - assume the default
      return "/reports";
    }
  }
}
